"use client";

import { useEffect, useRef } from "react";
import Script from "next/script";

function styleInputs(container: HTMLElement) {
  container.querySelectorAll<HTMLElement>(".hs-input").forEach((el) => {
    el.style.setProperty("color", "#dbdbdb", "important");
    el.style.setProperty("background", "#1A2436", "important");
    el.style.setProperty("border", "1px solid #2B3A52", "important");
    el.style.setProperty("border-radius", "8px", "important");
  });
}

export function HubSpotForm() {
  const containerRef = useRef<HTMLDivElement>(null);
  const created = useRef(false);

  function createForm() {
    if (created.current || !containerRef.current) return;
    // @ts-expect-error, hbspt is injected by the HubSpot script
    if (typeof window.hbspt === "undefined") return;
    created.current = true;
    // @ts-expect-error -- hbspt is not typed; injected by HubSpot embed script
    window.hbspt.forms.create({
      portalId: "25493898",
      formId: "c5119f31-7889-41e8-b407-2db371600d74",
      region: "eu1",
      target: "#hubspot-contact-form-target",
      css: "",
      cssRequired: "",
    });
  }

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new MutationObserver(() => styleInputs(container));
    observer.observe(container, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    createForm();
  }, []);

  return (
    <>
      <Script
        src="https://js-eu1.hsforms.net/forms/embed/v2.js"
        strategy="afterInteractive"
        onLoad={createForm}
      />
      <div id="hubspot-contact-form-target" className="hs-form-host" ref={containerRef} />
    </>
  );
}
